import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class EmailLogsService {
  fetchIndex(params) {
    return securedAxiosInstance.get("/email_logs", { params: toSnakeCase(params) });
  }
}

export default new EmailLogsService();
